import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';


import { AppComponent } from './app.component';
import { LMarkdownEditorModule } from 'ngx-markdown-editor';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DynamicFormsCoreModule } from "@ng-dynamic-forms/core";
import { DynamicFormsFoundationUIModule } from "@ng-dynamic-forms/ui-foundation";
import { ImageCropperModule } from 'ngx-image-cropper';
import { ImageManagerComponent } from './image-manager/image-manager.component';
import { StepDescriptionComponent } from './step-description/step-description.component';
import { DocsService } from './docs.service';
import { ExtTimePipe } from './ext-time.pipe';
import { GithubManagerService } from './github-manager.service';
import { HttpClientModule } from '@angular/common/http';


@NgModule({
  declarations: [
    AppComponent,
    ImageManagerComponent,
    StepDescriptionComponent,
    ExtTimePipe
  ],
  imports: [
    BrowserModule,
    FormsModule,
    LMarkdownEditorModule,
    ReactiveFormsModule,
    DynamicFormsCoreModule.forRoot(),
    DynamicFormsFoundationUIModule,
    ImageCropperModule,
    HttpClientModule
  ],
  providers: [
    DocsService,
    GithubManagerService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts